'use strict';

import { LogHelper } from 'com-gyf-webcore-loghelper';

import {
    GET_CONFIGURATION_SESSION_STARTS,
    GET_CONFIGURATION_SESSION_SUCCESS,
    INITIAL_STATE_CONFIGURATION_SESSION,
    SET_USER_FUNCTIONS_CONFSESIONVISTA,
    RESET_STATE_CONFIGSESIONVISTA
} from '../../Screens/ConfiguracionSesionVista/actions/ConfiguracionSesionVista';

const initialState = {
    isFetching: false,
    tipoConfiguracion: 0,
    functions: [],
    plataformas: [],

    alfabetica: false,
    cantIntentosFallidos: 0,
    cantidadRepeticiones: 0,
    caracteresEspeciales:false,
    caracteresMinimos: 0,
    caseSensitive: false,
    maxDiasCaducidad: 0,
    maxDiasInactividad: 0,              //idem para active directory
    minutosPermitidosInactividad: 0,    //idem para active directory
    numerica: false,
    permiteCaracteresIguales: false,
    permiteLetrasConsecutivas: false,
    permiteNrosConsecutivos: false,
    permiteRepetirPosicion: false,

    vincularGrupoWindows: false,
    altaAutomatica: false,
    soloUsuarioLoggeado: false,
    solicitarContrasenia: false

};

let result;


/**
 * 
 * @param {any} state
 * @param {any} action
 */
function configuracionSesionVista(state = initialState, action) {
    switch (action.type) {
        /*CARGA INICIAL*/
        case GET_CONFIGURATION_SESSION_STARTS:
            LogHelper.In(configuracionSesionVista.name, action, state);

            result = {
                ...state,
                isFetching: true
            };
            break;

        case RESET_STATE_CONFIGSESIONVISTA:
            LogHelper.In(configuracionSesionVista.name, action, state);

            result = initialState;
            break;

        /*SETEO DE FUNCIONES*/
        case SET_USER_FUNCTIONS_CONFSESIONVISTA:
            LogHelper.In(configuracionSesionVista.name, action, state);

            result = {
                ...state,
                functions: action.functions
            };
            break;

        /*DATOS DE BD*/
        case GET_CONFIGURATION_SESSION_SUCCESS:
            LogHelper.In(configuracionSesionVista.name, action, state);

            let maxDiasInactividad = action.result.GET_CONFIGURATION_PASSWORD_SESION[0].MaxDiasInactividad;
            let minutosPermitidosInactividad = action.result.GET_CONFIGURATION_PASSWORD_SESION[0].MinutosPermitidosInactividad;
            let cantIntentosFallidos = action.result.GET_CONFIGURATION_PASSWORD_SESION[0].CantIntentosFallidos;
            let cantidadRepeticiones = action.result.GET_CONFIGURATION_PASSWORD_SESION[0].CantidadRepeticiones;
            let caracteresMinimos = action.result.GET_CONFIGURATION_PASSWORD_SESION[0].CaracteresMinimos;
            let maxDiasCaducidad = action.result.GET_CONFIGURATION_PASSWORD_SESION[0].MaxDiasCaducidad;
            let tipoSeguridad = action.result.GET_CONFIGURATION_PASSWORD_TYPE[0].TipoSeguridad;

            result = {
                ...state,
                caracteresEspeciales: action.result.GET_CONFIGURATION_PASSWORD_SESION[0].CaracteresEspeciales,
                alfabetica: action.result.GET_CONFIGURATION_PASSWORD_SESION[0].Alfabetica,
                cantIntentosFallidos: cantIntentosFallidos == 0 ? null : cantIntentosFallidos,
                cantidadRepeticiones: cantidadRepeticiones == 0 ? null : cantidadRepeticiones,
                caracteresMinimos: caracteresMinimos == 0 ? null : caracteresMinimos,
                caseSensitive: action.result.GET_CONFIGURATION_PASSWORD_SESION[0].CaseSensitive,
                maxDiasCaducidad: maxDiasCaducidad == 0 ? null : maxDiasCaducidad,
                maxDiasInactividad: maxDiasInactividad == 0 ? null : maxDiasInactividad,
                minutosPermitidosInactividad: minutosPermitidosInactividad == 0 ? null : minutosPermitidosInactividad,
                numerica: action.result.GET_CONFIGURATION_PASSWORD_SESION[0].Numerica,
                permiteCaracteresIguales: action.result.GET_CONFIGURATION_PASSWORD_SESION[0].PermiteCaracteresIguales,
                permiteLetrasConsecutivas: action.result.GET_CONFIGURATION_PASSWORD_SESION[0].PermiteLetrasConsecutivas,
                permiteNrosConsecutivos: action.result.GET_CONFIGURATION_PASSWORD_SESION[0].PermiteNrosConsecutivos,
                permiteRepetirPosicion: action.result.GET_CONFIGURATION_PASSWORD_SESION[0].PermiteRepetirPosicion,
                plataformas: action.result.GET_TIPO_PLATAFORMA,

                vincularGrupoWindows: action.result.GET_CONFIGURATION_PASSWORD_TYPE[0].VincularGrupoWindows,
                altaAutomatica: action.result.GET_CONFIGURATION_PASSWORD_TYPE[0].AltaAutomatica,
                soloUsuarioLoggeado: action.result.GET_CONFIGURATION_PASSWORD_TYPE[0].SoloUsuarioLoggeado,
                solicitarContrasenia: action.result.GET_CONFIGURATION_PASSWORD_TYPE[0].SolicitarContrasenia,
                tipoConfiguracion: tipoSeguridad == "GYF" ? 1 : 2,

                isFetching: false
            };
            break;

        case INITIAL_STATE_CONFIGURATION_SESSION:
            LogHelper.In(configuracionSesionVista.name, action, state);

            result = initialState;
            break;

        default:
            LogHelper.In(configuracionSesionVista.name, action, state);

            result = { ...state };
            break;
    }

    LogHelper.Out(configuracionSesionVista.name, result);
    return result;
}

export default configuracionSesionVista;